import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useExtendedVideoPlayerStyles = makeStyles(({ spacing }) => {
  return createStyles({
    playerWrapper: {
      height: '100%',
      width: '100%',
      paddingTop: spacing(7),
      objectFit: 'cover',
      objectPosition: 'center',
    },
    videoPlayer: {
      height: '100%',
      width: '100%',
    },
    noVisibility: {
      visibility: 'hidden',
    },
  });
});

export default useExtendedVideoPlayerStyles;
